var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 190,
    viewBox: "0 0 221 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 80,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_1705_42346)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 49.3048C105.039 47.8015 110.247 47.7643 115.14 49.1978L201.676 74.5467C207.399 76.2232 207.437 84.3173 201.729 86.0469L115.378 112.214C110.337 113.742 104.95 113.702 99.9323 112.101L18.214 86.0202C12.618 84.2343 12.6564 76.3026 18.2695 74.5709L100.166 49.3048Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.875 62.5H135.5C140.678 62.5 144.875 58.3031 144.875 53.125V21.875C144.875 16.6969 140.678 12.5 135.5 12.5H119.875C114.697 12.5 110.5 16.6969 110.5 21.875V53.125C110.5 58.3031 114.697 62.5 119.875 62.5Z",
    fill: "#BDCEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.375 28.125H88.625C92.0781 28.125 94.875 25.3281 94.875 21.875V15.625C94.875 12.1719 92.0781 9.375 88.625 9.375H82.375C78.9219 9.375 76.125 12.1719 76.125 15.625V21.875C76.125 25.3281 78.9219 28.125 82.375 28.125Z",
    fill: "#BDCEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.375 62.5H88.625C92.0781 62.5 94.875 59.7031 94.875 56.25V50C94.875 46.5469 92.0781 43.75 88.625 43.75H82.375C78.9219 43.75 76.125 46.5469 76.125 50V56.25C76.125 59.7031 78.9219 62.5 82.375 62.5Z",
    fill: "#BDCEEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4375 56.25H94.875V50H96.4375C98.1625 50 99.5625 48.5969 99.5625 46.875V25C99.5625 23.2781 98.1625 21.875 96.4375 21.875H94.875V15.625H96.4375C101.606 15.625 105.812 19.8312 105.812 25V32.8125H110.5V39.0625H105.812V46.875C105.812 52.0437 101.606 56.25 96.4375 56.25Z",
    fill: "url(#paint1_linear_1705_42346)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.437 28.125H133.937C136.525 28.125 138.625 26.0281 138.625 23.4375C138.625 20.8469 136.525 18.75 133.937 18.75H121.437C118.85 18.75 116.75 20.8469 116.75 23.4375C116.75 26.0281 118.85 28.125 121.437 28.125Z",
    fill: "url(#paint2_linear_1705_42346)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.437 40.625H133.937C136.525 40.625 138.625 38.5281 138.625 35.9375C138.625 33.3469 136.525 31.25 133.937 31.25H121.437C118.85 31.25 116.75 33.3469 116.75 35.9375C116.75 38.5281 118.85 40.625 121.437 40.625Z",
    fill: "url(#paint3_linear_1705_42346)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.688 56.25C125.099 56.25 123 54.1513 123 51.5625C123 48.9737 125.099 46.875 127.688 46.875C130.276 46.875 132.375 48.9737 132.375 51.5625C132.375 54.1513 130.276 56.25 127.688 56.25Z",
    fill: "url(#paint4_linear_1705_42346)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1705_42346",
    x1: 206,
    y1: 135,
    x2: 14,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1705_42346",
    x1: 102.688,
    y1: 15.625,
    x2: 102.688,
    y2: 56.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1705_42346",
    x1: 127.687,
    y1: 18.75,
    x2: 127.687,
    y2: 28.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1705_42346",
    x1: 127.687,
    y1: 31.25,
    x2: 127.687,
    y2: 40.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1705_42346",
    x1: 127.688,
    y1: 46.875,
    x2: 127.688,
    y2: 56.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.747b4a985aef1655cb95dd130dab8841.svg";
export { ForwardRef as ReactComponent };